import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Global } from "../../../Variables/Global";
import axiosInstance from '../../../api/axiosConfig';

const ManageProduct = () => {
    var pId = useParams();
    var navigate = useNavigate();
     
    const [pageType, setPageType] = useState("Add");
    const [productName, setProductName] = useState("");
    const [description, setDescription] = useState("");
    const [companyId, setCompanyId] = useState(0);
    const [companies, setCompanies] = useState([]);

    const GetProduct = (productId) =>{
        var config = {
            method: 'get',
            url: "Product/GetProduct/" + productId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                document.title = response.data.productName;
                setProductName(response.data.productName)
                setDescription(response.data.description)
                setCompanyId(response.data.companyId)
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const GetCompanies = () => {
        var config = {
            method: 'get',
            url: "Company/GetCompany",
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                setCompanies(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const submitForm = (e) => {
        e.preventDefault();
        if (IsValid()) {
            const body = { 
                productName: productName, 
                description:description, 
                userId: localStorage.getItem("uTsReD"),
                companyId: companyId 
            }
            if (pId.ProductId == "0") { //Add Product
                var config = {
                    method: 'post',
                    url: "Product/AddProduct",
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': Global.Host
                    },
                    data: body
                };

                axiosInstance(config)
                    .then(function (response) {
                        if(response.status === 200){
                            toast.success("Product Added Successfully")
                            navigate("/Settings/Product")
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        toast.error("Something Went Wrong")
                    });
            }
            else { // Update Product
                var config = {
                    method: 'put',
                    url: "Product/EditProduct/" + pId.ProductId,
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': Global.Host
                    },
                    data: body
                };

                axiosInstance(config)
                    .then(function (response) {
                        if(response.status === 200){
                            toast.success("Product Updated Successfully")
                            navigate("/Settings/Product")
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        toast.error("Something Went Wrong")
                    });
            }
        }
    }

    const IsValid = () => {
        if (productName == "" && companyId == "0") {
            toast.error("Enter all required fields");
            return false;
        }
        else if (productName == "") {
            toast.error("Enter Size Name");
            return false;
        }
        else if (companyId == "0") {
            toast.error("Select Company");
            return false;
        }
        return true;
    }

    useEffect(() => {
        GetCompanies();
        if (pId.ProductId != "0") {
            setPageType("Edit");
            GetProduct(pId.ProductId)
        }
    }, [])
    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="page-title-box">
                                <h4>Products</h4>
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><a href="#">Mercator</a></li>
                                    <li className="breadcrumb-item"><Link to="/Settings/Products">Products</Link></li>
                                    <li className="breadcrumb-item active">{pageType} Product</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="mb-3 row">
                                        <div className="col-12 col-md-6">
                                            <h4 className="card-title">{pageType} Product</h4>
                                        </div>
                                        <div className="col-12 col-md-6 text-right">
                                            <Link to="/Settings/Product" className="btn btn-secondary mr-3">Cancel</Link>
                                            <button className="btn btn-primary" onClick={(e) => submitForm(e)}>Submit</button>
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <div className="col-md-6">
                                            <label htmlFor="txtSizeName" className="col-md-12 col-form-label">Product Name</label>
                                            <input className="form-control" type="text" value={productName} id="txtSizeName" onChange={(e) => setProductName(e.target.value)} required />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="col-md-12 col-form-label">Company</label>
                                            <select className="form-control" value={companyId} onChange={(e) => setCompanyId(e.target.value)} required>
                                                <option value="0" key="0">-- Select Company Name --</option>
                                                {companies.length > 0 && (
                                                    companies.map((c, index) => {
                                                        return (<>
                                                            <option value={c.companyId} key={index}>{c.companyName}</option>
                                                        </>)
                                                    })
                                                )}
                                            </select>
                                        </div>
                                        <div className="col-md-12">
                                            <label htmlFor="txtSizeName" className="col-md-12 col-form-label">Description</label>
                                            <textarea className="form-control" type="text" value={description} id="txtSizeName" onChange={(e) => setDescription(e.target.value)} required />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default ManageProduct;